import appConfig from '../../static/data/env/envSettings';

export const captchaOperators = ['+', '-', '*', '/'];

export const loginFieldType = {
    _userlogin_: 'username',
    _userpwd_: 'userpassword',
    _voucheruid_: 'voucheruuid',
    _useremail_: 'useremail',
    _forgetanswer_: 'forgetanswer'
};

export const _loginErrorType = {
    noUserLogin: {
        msg: 'Please enter your login ID',
        fields: [loginFieldType._userlogin_]
    },
    noUserEmail: {
        msg: 'Please enter your email address',
        fields: [loginFieldType._useremail_]
    },
    noPwd: {
        msg: 'Please enter your password',
        fields: [loginFieldType._userpwd_]
    },
    noCredentials: {
        msg: 'Please enter your login ID/password',
        fields: [loginFieldType._userlogin_, loginFieldType._userpwd_]
    },
    noVoucheruid: {
        msg: 'Please fill the voucher code',
        fields: [loginFieldType._voucheruid_]
    },
    noAnswer: {
        msg: 'Please fill the answer',
        fields: [loginFieldType._forgetanswer_]
    },
    badAnswer: {
        msg: 'Incorrect result',
        fields: [loginFieldType._forgetanswer_]
    }
};

export function validateCredentials(username, password) {
    const isUserNameEmpty = !username || username.trim().length === 0;
    const isPwdEmpty = !password || password.trim().length === 0;

    if (isUserNameEmpty && isPwdEmpty) {
        return _loginErrorType.noCredentials;
    } else if (isUserNameEmpty) {
        return _loginErrorType.noUserLogin;
    } else if (isPwdEmpty) {
        return _loginErrorType.noPwd;
    }
    return {};
}

export function validateForgetSubmit(activeTab, field, answer) {
    const isFieldEmpty = !field || field.trim().length === 0;
    if (isFieldEmpty) {
        return activeTab === 'pwd'
            ? _loginErrorType.noUserLogin
            : _loginErrorType.noUserEmail;
    }
    const isAnswerEmpty = !answer || answer.trim().length === 0;
    if (isAnswerEmpty) {
        return _loginErrorType.noAnswer;
    }
    return {};
}

export function getCaptchaResult(captchaOptions) {
    const {captchaL, captchaR, captchaOperator} = captchaOptions;
    if (captchaOperator === '*') {
        return captchaL * captchaR;
    } else if (captchaOperator === '+') {
        return captchaL + captchaR;
    } else if (captchaOperator === '/') {
        return captchaL / captchaR;
    }
    return captchaL - captchaR;
}

export function isVoucherEmpty(voucheruid) {
    if (!voucheruid || voucheruid.trim().length === 0) {
        return _loginErrorType.noVoucheruid;
    }
    return {};
}
export function getRegistrerVoucherUrlOnly(baseUrl, voucheruuid) {
    const {
        controllerUrl,
        actionParam,
        initActionParam,
        uuidParam
    } = appConfig.voucherSettings;
    return `${baseUrl}/${controllerUrl}?${actionParam}=voucher_auth&${uuidParam}=${voucheruuid}&${initActionParam}=true`;
}
export function getRegistrerVoucherUrl(baseUrl, voucheruuid) {
    const pUrl = sessionStorage.getItem('pUrl');

    let redirectUrl;
    if (window.location.href.split('service=')[1] && window.location.href.split('service=')[1].includes('up')) {
        redirectUrl = window.location.href.split('service=')[1];
    } else {
        redirectUrl = `${baseUrl}${'/ui/#/user/'}${'?vuid='}${voucheruuid}`;
    }

    const encodedRediUrl = encodeURIComponent(redirectUrl);
    return `${pUrl}${'?service='}${encodedRediUrl}`;
}

/**
 * @returns create 3DEx id url
 * @description reuse register voucher process with special voucher id
 * @param {*} baseUrl
 */
export function getCreate3DExIdUrl(baseUrl) {
    const {
        controllerUrl,
        actionParam,
        initActionParam,
        uuidParam
    } = appConfig.voucherSettings;
    return `${baseUrl}/${controllerUrl}?${actionParam}=voucher_auth&${uuidParam}=ext&${initActionParam}=true`;
}

export function getLoginDSPUrl(baseUrl) {
    debugger;
    const pUrl = sessionStorage.getItem('pUrl');
    let redirectUrl;
    if (window.location.href.split('service=')[1].includes('up') || window.location.href.split('service=')[1].includes('launchExam')) {
        console.log('---wow---');
        console.log(redirectUrl);
        redirectUrl = window.location.href.split('service=')[1];
    } else if (window.location.href.split('service=')[1].includes('public')) {
        redirectUrl = `${baseUrl}${'/ui/#/user/'}`;
    } else {
        redirectUrl = window.location.href.split('service=')[1];
    }
    const encodedRediUrl = encodeURIComponent(redirectUrl);
    return `${pUrl}${'?service='}${encodedRediUrl}`;
    // return `${pUrl}${'?service=https%3A%2F%2Feduspace-qals.itvpc.3ds.com%2FCompanionManager%2Fui%2F%23%2Fuser%2F'}`;
    // return 'https://eu1-dsi-iam.3dexperience.3ds.com/login?service=https%3A%2F%2Feduspace-qals.itvpc.3ds.com%2FCompanionManager%2Fcls%2Flogin%2FCATCmaUserAthenticationServletDSP%2FloginDSP';
    // return 'https://eu1-dsi-iam.3dexperience.3ds.com/login?service=https%3A%2F%2Feduspace-ppdqa.3ds.com%2FCompanionManager%2Fui%2F%23%2Fuser%2F';
}

export function getRedirectionUrl(baseUrl, result) {
    let redirectUrl;
    if (window.location.href.split('service=')[1].includes('up') || window.location.href.split('service=')[1].includes('launchExam')) {
        redirectUrl = window.location.href.split('service=')[1];
        // return redirectUrl;
    } else {
        switch (result) {
            case 'successAdmin':
                redirectUrl = `${baseUrl}/${appConfig.clsUrls.adminUrl}`;
                break;
            case 'successStudent':
                redirectUrl = `${baseUrl}/${appConfig.clsUrls.studentUrl}`;
                break;
            case 'successTeacher':
                redirectUrl = `${baseUrl}/${appConfig.clsUrls.teacherUrl}`;
                break;
            case 'successAuthor':
                redirectUrl = `${baseUrl}/${appConfig.clsUrls.authorUrl}`;
                break;
            case 'CATCmaTermsofUse':
                redirectUrl = `${baseUrl}/${appConfig.clsUrls.termOfUseUrl}`;
                break;
            case 'changePassword':
                redirectUrl = `${baseUrl}/${appConfig.clsUrls.changePwdUrl}`;
                break;
            case 'CATCmaStudentTrainingPlan':
                redirectUrl = `${baseUrl}/${appConfig.clsUrls.assignmentUrl}`;
                break;
            case 'CATCmaInAccessibleLinkPage':
                redirectUrl = `${baseUrl}/${appConfig.clsUrls.inAccessibleLinkUrl}`;
                break;
            case 'downloadCourseDocumentsPage':
                redirectUrl = `${baseUrl}/${appConfig.clsUrls.coursewareDownloadUrl}`;
                break;
            case 'errorLink':
                redirectUrl = `${baseUrl}/${appConfig.clsUrls.errorLink}`;
                break;
            case 'pdfDownload':
                redirectUrl = `${baseUrl}/${appConfig.clsUrls.pdfDownload}`;
                break;
            default:
                redirectUrl = '';
        }
    }
    return redirectUrl;
}

/**
 * @ngdoc method
 * @name getDivisors
 * @methodOf cls.captchaUtility
 * @description gets the operator and operands for captcha
 * @param {int} n number for which divisor will be returned
 * @return {int} return the divisor of the number
 */
function getDivisors(n) {
    if (n < 1) {
        n = 0;
    }
    const small = [];
    const large = [];
    const end = Math.floor(Math.sqrt(n));
    for (let i = 1; i <= end; i++) {
        if (n % i === 0) {
            small.push(i);
            if (i * i !== n) {
                large.push(n / i);
            }
        }
    }
    large.reverse();
    return small.concat(large);
}

export function getOperations() {
    let captchaL, captchaR, num;
    const operator =
        captchaOperators[Math.floor(Math.random() * captchaOperators.length)];
    captchaL = Math.floor(Math.random() * (16 - 6) + 6);
    if (operator === '/') {
        num = getDivisors(captchaL);
        captchaR = num[Math.floor(Math.random() * num.length)];
    } else {
        captchaR = Math.floor(Math.random() * 5 + 1);
        while (captchaL < captchaR) {
            captchaL = Math.floor(Math.random() * 15);
            captchaR = Math.floor(Math.random() * 5 + 1);
        }
    }
    return {
        captchaL,
        captchaR,
        captchaOperator: operator
    };
}

export function getSearchParams(search) {
    if (window.location.hash.split('#/').length <= 1) {
        return {};
    }
    const searchParams = {};

    try {
        const searchArray = window.location.hash
            .replace(/^#\/\?/, '')
            .split('&');
        searchArray.forEach((pair) => {
            const params = pair.split('=');
            searchParams[params[0]] = params[1];
        });
        return searchParams;
    } catch (err) {
        return {};
    }
}
